import { render, staticRenderFns } from "./onlineExhibition.vue?vue&type=template&id=f670b584&scoped=true"
import script from "./onlineExhibition.vue?vue&type=script&lang=js"
export * from "./onlineExhibition.vue?vue&type=script&lang=js"
import style0 from "./onlineExhibition.vue?vue&type=style&index=0&id=f670b584&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f670b584",
  null
  
)

export default component.exports